module.exports = __webpack_public_path__ + "img/成果展示高校院所.4c9f23bc.png";